import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/loginRegister/showEye.png'
import _imports_1 from '@/assets/loginRegister/hideEye.png'


const _hoisted_1 = { class: "cryptoWIthdrawContainer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "textTitle" }
const _hoisted_4 = { class: "crypto_field" }
const _hoisted_5 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_6 = { class: "crypto_field" }
const _hoisted_7 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_8 = { class: "btn_container" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "crypto_field" }
const _hoisted_11 = { class: "right_Icons" }
const _hoisted_12 = { class: "crypto_field" }
const _hoisted_13 = { class: "crypto_field" }
const _hoisted_14 = { class: "crypto_field" }
const _hoisted_15 = { class: "btn_container" }

import { formatCurrency } from '@/utils/commonFunction';
import { ref, onUnmounted, onMounted, watch, computed } from 'vue';
import MainButton from '../components/common/mainButton.vue';
import AddressBookPopup from './components/addressBookPopup.vue';
import NetworkSelectPopup from './components/networkSelectPopup.vue';
import { callNetworkOptions, callWithdraw, useScanner } from '@/view/withdraw/supportScript';
import { useUserStore } from '@/stores/user';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { checkConfirmPasswordValidation, checkWithdrawPasswordValidation, updateWithdrawPassword } from '@/view/profile/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'cryptoWithdraw',
  setup(__props) {

const userStore = useUserStore()
const address = ref('')
const network = ref('')
const securityPassword = ref('')
const withdrawalAmount = ref('')
const withdrawMin = ref(0)
const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
// const availableBalance = ref(0)
const addressBookPopupRef = ref()
const networkPopupRef = ref()
const networkList = ref([])
const selectedNetwork = ref<any>({})
const uId = ref(userStore.id)


const isShow = ref(false)
const isShowconfirm = ref(false)
const newPassword = ref('')
const confirmPassword = ref('')
const passwordValidationNotice = ref(false)
const confirmPasswordValidationNotice = ref(false)
const isSubmitBtnActivated = computed(() => {
    return (
        newPassword.value.length > 0 &&
        confirmPassword.value.length > 0 &&
        !passwordValidationNotice.value &&
        !confirmPasswordValidationNotice.value &&
        newPassword.value == confirmPassword.value
    );
})
const passwordChange = (value: string) => {
    newPassword.value = value
    checkWithdrawPasswordValidation(value, passwordValidationNotice)
    checkConfirmPasswordValidation(confirmPassword.value, confirmPassword, newPassword, confirmPasswordValidationNotice)
}

const confirmPasswordChange = (value: string) => {
    confirmPassword.value = value
    checkConfirmPasswordValidation(value, confirmPassword, newPassword, confirmPasswordValidationNotice)
}
const handleUpdatePassword = () => {
    updateWithdrawPassword('', newPassword.value, ref(false), toastContent, isSuccess, statusRef)
}
const handleShowPassword = () => {
    isShow.value = !isShow.value
}
const handleShowConfirmPassword = () => {
    isShowconfirm.value = !isShowconfirm.value
}

const buttonActive = computed(() => {
    return (
        address.value.trim() !== '' &&
        network.value.trim() !== '' &&
        securityPassword.value.trim() !== '' &&
        withdrawalAmount.value !== '' &&
        Number(withdrawalAmount.value) > 0
    );
});
const { showScanner, startScanner, stopScanner } = useScanner();

const handleStartScan = () => {
    startScanner('reader', (result) => {
        address.value = result;
    });
};

const showAddressPopup = () => {
    addressBookPopupRef.value.openPopup()
}

const showNetworkPopup = () => {
    networkPopupRef.value.openPopup()
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const confirmWithdraw = async () => {
    loadingRef.value.open()
    const { data } = await callWithdraw(address.value, uId.value, withdrawalAmount.value, selectedNetwork.value.id, securityPassword.value)
    if (data.code == 200) {
        loadingRef.value.close()
        showSuccess(data.msg)
    } else {
        loadingRef.value.close()
        showError(data)
    }
}

const getNetworkOption = async (addr?: string) => {
    if (addr) {
        address.value = addr
    }

    const { network_list } = await callNetworkOptions(address.value)
    networkList.value = network_list

}

const setSelecteddNetwork = (networkData: any) => {
    selectedNetwork.value = networkData
    network.value = networkData?.channelName
    networkPopupRef.value.closePopup()
}

watch(() => newPassword.value, (val) => {
    passwordChange(val)
})
watch(() => confirmPassword.value, (val) => {
    confirmPasswordChange(val)
})

watch(() => address.value, (newVal) => {
    getNetworkOption()
    network.value = ''
})
onUnmounted(() => {
    stopScanner();
});
onMounted(() => {
    getNetworkOption()
})


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(userStore).withdrawPassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('profile.withdrawalPassword')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.securityPassword')), 1),
            _createVNode(_component_van_field, {
              modelValue: newPassword.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
              type: isShow.value ? 'text' : 'password',
              placeholder: _ctx.$t('profile.enterNewPassword')
            }, {
              "right-icon": _withCtx(() => [
                _createElementVNode("div", null, [
                  (isShow.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_0,
                        alt: "",
                        width: "18px",
                        class: "iconImage",
                        onClick: handleShowPassword
                      }))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_1,
                        alt: "",
                        width: "18px",
                        class: "iconImage",
                        onClick: handleShowPassword
                      }))
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "type", "placeholder"]),
            (passwordValidationNotice.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('profile.cnofirmNewPassword')), 1),
            _createVNode(_component_van_field, {
              modelValue: confirmPassword.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmPassword).value = $event)),
              type: isShowconfirm.value ? 'text' : 'password',
              placeholder: _ctx.$t('profile.cnofirmNewPassword')
            }, {
              "right-icon": _withCtx(() => [
                _createElementVNode("div", null, [
                  (isShowconfirm.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_0,
                        alt: "",
                        width: "18px",
                        class: "iconImage",
                        onClick: handleShowPassword
                      }))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _imports_1,
                        alt: "",
                        width: "18px",
                        class: "iconImage",
                        onClick: handleShowConfirmPassword
                      }))
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "type", "placeholder"]),
            (confirmPassword.value && newPassword.value && confirmPassword.value !== newPassword.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('loginRegister.differentPassword')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(MainButton, {
              title: _ctx.$t('profile.save'),
              activeStatus: isSubmitBtnActivated.value,
              onClick: handleUpdatePassword
            }, null, 8, ["title", "activeStatus"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.address')), 1),
            _createVNode(_component_van_field, {
              modelValue: address.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((address).value = $event)),
              placeholder: _ctx.$t('withdraw.address')
            }, {
              "right-icon": _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_van_icon, {
                    name: "user-circle-o",
                    size: "22",
                    style: {"padding-right":"15px"},
                    onClick: showAddressPopup
                  }),
                  _createVNode(_component_van_icon, {
                    name: "scan",
                    size: "22",
                    onClick: handleStartScan
                  })
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.network')), 1),
            _createElementVNode("div", {
              class: "networkField",
              onClick: showNetworkPopup
            }, _toDisplayString(network.value ? network.value : _ctx.$t('withdraw.network')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.securityPassword')), 1),
            _createVNode(_component_van_field, {
              modelValue: securityPassword.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((securityPassword).value = $event)),
              type: "password",
              placeholder: _ctx.$t('withdraw.securityPassword')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('withdraw.withdrawalAmount')), 1),
            _createVNode(_component_van_field, {
              modelValue: withdrawalAmount.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((withdrawalAmount).value = $event)),
              type: "number",
              placeholder: _ctx.$t('withdraw.withdrawalMinAmount', { value: withdrawMin.value })
            }, {
              "right-icon": _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "rightText" }, [
                  _createTextVNode(" USDT "),
                  _createElementVNode("span", null, "Max")
                ], -1)
              ])),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(MainButton, {
              title: _ctx.$t('common.sake'),
              activeStatus: buttonActive.value,
              onClick: confirmWithdraw
            }, null, 8, ["title", "activeStatus"])
          ])
        ])),
    _createVNode(_component_van_popup, {
      show: _unref(showScanner),
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showScanner) ? (showScanner).value = $event : null)),
      class: "transparent-scanner-popup",
      onClosed: _unref(stopScanner),
      "overlay-style": { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
    }, {
      default: _withCtx(() => _cache[7] || (_cache[7] = [
        _createElementVNode("div", { class: "scanner-wrapper" }, [
          _createElementVNode("div", { id: "reader" })
        ], -1)
      ])),
      _: 1
    }, 8, ["show", "onClosed"]),
    _createVNode(AddressBookPopup, {
      ref_key: "addressBookPopupRef",
      ref: addressBookPopupRef
    }, null, 512),
    _createVNode(NetworkSelectPopup, {
      ref_key: "networkPopupRef",
      ref: networkPopupRef,
      networkList: networkList.value,
      onSelectNetwork: setSelecteddNetwork
    }, null, 8, ["networkList"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ]))
}
}

})